import type { GeckoMeasurementUnit } from 'types'

export function formatAxisTitle(
  name: string | undefined,
  unit: GeckoMeasurementUnit | string | undefined
) {
  if (!name) return ''
  const unitLabel = formatAxisUnit(unit)
  return unitLabel ? `${name} (${unitLabel})` : name
}

export function formatAxisUnit(unit: GeckoMeasurementUnit | string | undefined) {
  if (!unit) return ''
  const unitId = typeof unit === 'string' ? unit : unit.id
  switch (unitId) {
    case 'ft':
      return 'ft'
    case 'in':
      return 'in'
    case 'm':
      return 'm'
    case 'mm':
      return 'mm'
    case 'deg':
      return 'deg'
    default:
      return unitId
  }
}
